import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { inject, ref } from "vue";
//import inject symbol
import { deactivateNavSymbol } from "@/injection";
//import composable
import { useToggle } from "@toolsie/composables";
//import and define props
import { navElementProps } from "@/props";
//define the props

import { defineComponent } from "vue";
const __default__ = defineComponent({
  name: "NavElement",
  inheritAttrs: true,
});


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: navElementProps,
  setup(__props) {

//import vue

//get the injected value from the container
const deactivateMenuKey = inject(deactivateNavSymbol, ref(false));
//get the toggler for the provided value
let { toggle: deactivateMenu } = useToggle(deactivateMenuKey);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toolsie nav element", { active: _ctx.active, inactive: !_ctx.active, fixed: _ctx.fixed, loose: !_ctx.fixed }]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(deactivateMenu)()))
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})